<template>
    <div class="cvv-modal">
        <div class="cvv-modal__overlay" @click="$emit('close-modal')" />
        <div class="cvv-modal__content">
            <div class="cvv-modal__header">
                <h6 class="cvv-modal__title">
                    <span v-text="$ml.get('securityCVV')" />
                </h6>
                <button
                    class="cvv-modal__btn-close"
                    @click="$emit('close-modal')"
                >
                    <img src="@/assets/img/icons/close-blue.svg" alt="" tabindex="-1" />
                </button>
            </div>

            <div class="cvv-modal__body">
                <CieloInputV2
                    :borderless="false"
                    name="SecurityCode"
                    label="CVV"
                    @input="value => $emit('input-security-code', value)"
                    :value="securityCode"
                    v-validate="'required|min:3|max:4'"
                    :data-vv-as="$ml.get('securityCode')"
                    :error="errors.first('SecurityCode')"
                    type="tel"
                    :mask="['####']"
                />
            </div>

            <div class="cvv-modal__footer">
                <CieloButton @click="$emit('submit-cvv')">
                    <span
                        class="btn-text btn-next"
                        style="font-weight: 600;"
                        v-text="$ml.get('send')"
                    />
                </CieloButton>
            </div>
        </div>
    </div>
</template>

<script>
const CieloInputV2 = () =>
	import(/* webpackChunkName: "cielo-input-v2" */
	'@/components/ClickToPay/template/CieloInputV2');

const CieloButton = () =>
	import(/* webpackChunkName: "cielo-button" */
	'@/components/template/CieloButton');

export default {
	components: {
		CieloInputV2,
		CieloButton
	},

	props: {
		securityCode: {
			type: String,
			default: ''
		}
	}
};
</script>

<style lang="scss" scoped>
.cvv-modal {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 99999;
	display: inline-flex;
	flex-direction: column;

	&__overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: -1;
		background-color: rgba(32, 31, 32, 0.6);
	}

	&__content {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: #ffffff;
		padding: 24px 16px;
		border-radius: 8px;

		//mobile
		@media screen and (max-width: 767px) {
			width: calc(100% - 32px);
		}

		//desktop
		@media screen and (min-width: 768px) {
		}
	}

	&__header {
		margin-bottom: 32px;
	}

	&__body {
		margin-bottom: 32px;
	}

	&__footer {
	}

	&__title {
		font-size: 18px;
		font-weight: 700;
		color: #2f363e;
		margin-right: 40px;
	}

	&__btn-close {
		cursor: pointer;
		background-color: transparent;
		border: none;
		position: absolute;
		top: 16px;
		right: 16px;
		padding: 0;
	}

	&__btn-submit {
	}
}
</style>
